import { Button, Typography } from '@mui/material';
import Layout from 'client/modules/App/components/Layout/LayoutContainer';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const messages = defineMessages({
  title: {
    id: 'CheckoutError.Title',
    defaultMessage: 'Subscription checkout failed',
  },
});

function CheckoutErrorPage({ intl: { formatMessage } }) {
  return (
    <Layout>
      <Helmet title={formatMessage(messages.title)} />
      <Typography variant="h5" component="h1" gutterBottom>
        <FormattedMessage
          id="CheckoutError.Heading"
          defaultMessage="We couldn't complete your subscription"
        />
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        <FormattedMessage
          id="CheckoutError.Body"
          defaultMessage="Something went wrong during checkout. You can try again or contact us if the problem persists."
        />
      </Typography>
      <Button component={Link} to="/pricing" variant="contained" color="primary">
        <FormattedMessage id="CheckoutError.BackToPricing" defaultMessage="Back to pricing" />
      </Button>
    </Layout>
  );
}

CheckoutErrorPage.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default CheckoutErrorPage;
